import loadable from '@loadable/component';

export const SeasonalEventCountdown = loadable(
  () => import(/* webpackChunkName: 'seasonal-event-countdown' */ './SeasonalEventCountdown'),
);
